export type DPI = typeof DPIS[number];
export const DPIS = ["10", "72", "96", "150", "200", "240", "300", "360", "600", "1200"] as const;
